var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recipe-status-wrapper"},[_c('div',{class:[
      'recipe-status draft',
      { draft: _vm.isDraft, flagged: _vm.isPublishedFlagged } ]},[(_vm.isDraftFlagged)?_c('span',[_c('BaseIcon',{staticClass:"icon-flag",attrs:{"name":"flag"}})],1):_vm._e(),_vm._v(" "+_vm._s(_vm.status)+" ")]),_c('p',[_vm._v(_vm._s(_vm.statusText))])])}
var staticRenderFns = []

export { render, staticRenderFns }